import { render, staticRenderFns } from "./partnerPrintRemittance.vue?vue&type=template&id=2a67ffe8&scoped=true&"
import script from "./partnerPrintRemittance.vue?vue&type=script&lang=js&"
export * from "./partnerPrintRemittance.vue?vue&type=script&lang=js&"
import style0 from "./partnerPrintRemittance.vue?vue&type=style&index=0&id=2a67ffe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67ffe8",
  null
  
)

export default component.exports